import React from 'react'
import { Partners } from '@shared/lib/partner'

export const getTitleByPartner = (partner: Partners) => {
  switch (partner) {
    case Partners.DEFAULT:
      return <>Выберите способ&nbsp;оплаты</>
    default:
      return 'К оплате'
  }
}
